// src/components/BackgroundSlider.js
import React, { useState, useEffect } from 'react';
import './BackgroundSlider.css';

export default function BackgroundSlider() {
    const desktopImages = [
        '/images/lokal1.jpg',
        '/images/lokal2.jpg',
        '/images/lokal3.jpg',
        '/images/lokal4.jpg',
    ];

    const mobileImages = [
        '/images/1.jpg',
        '/images/2.jpg',
        '/images/3.jpg',
        '/images/4.jpg',
    ];

    const [current, setCurrent] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    // 1. NOWY STAN: Flaga informująca, czy strona już "wstała"
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);

        // 2. TRIK Z ANIMACJĄ: Czekamy 50 milisekund i dopiero pozwalamy na dodanie klasy 'active'
        const timer = setTimeout(() => setIsMounted(true), 50);

        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(timer);
        };
    }, []);

    const images = isMobile ? mobileImages : desktopImages;

    useEffect(() => {
        if (images.length > 1) {
            const interval = setInterval(() => {
                setCurrent(prev => (prev + 1) % images.length);
            }, 5000);
            return () => clearInterval(interval);
        }
    }, [images]);

    return (
        <div className="background-slider">
            {images.map((img, index) => (
                <img
                    key={index}
                    src={img}
                    // 3. POPRAWKA SEO: Pozbywamy się "tło 0 tło 1" z Google!
                    // Pusty alt dla dekoracji, albo ładny opis dla pierwszego zdjęcia.
                    alt={index === 0 ? "Wnętrze Męskiego Lokalu w Brzegu" : ""}

                    // 4. KLASA ACTIVE: Dodawana tylko wtedy, gdy current się zgadza ORAZ strona jest już zamontowana
                    className={`bg-image ${index === current && isMounted ? 'active' : ''}`}
                />
            ))}
        </div>
    );
}